import { Button, Form, Select, DatePicker, Spin, Image, notification } from "antd";
import { useState, useRef, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row as Brow, Col as Bcol } from "reactstrap";
import numeral from "numeral";
import moment from "moment";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ReadCookie } from "../../utils/readCookie";
import { TabTitle } from "../../utils/GeneralFunction";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getTopImmediateOts } from "../../redux/actions/crmCustomerReport.action";
import axios from "axios";
import { saveAs } from "file-saver";
import { BASEURL } from "../../constant/config";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import noImage from "../../assets/images/noImage.png"
import { getRights } from "../../redux/actions/userRights.action";
import ScheduleModal from "../../components/ScheduleModal/ScheduleModal";
const { Option } = Select;

const TopImmediateOts = () => {
  TabTitle("Top Immediate OTS")
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const queryParams = new URLSearchParams(window.location.search);
  const { customerForms, topImmediateOts, gender, season } = useSelector((state) => state);
  const focusInput = useRef(null);
  const [customer, setCustomer] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scheduleData, setScheduleData] = useState({});
  const [userRights, setUserRights] = useState(false);



  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);

  useEffect(() => {
    dispatch(getSeason(token, menuId));
    dispatch(getGender(token, menuId));
  }, [dispatch, menuId, token]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await dispatch(getTopImmediateOts(token, values));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };





  const groupedData =
    topImmediateOts?.payload?.data?.reduce((acc, item) => {
      const season = item.current_season;

      if (!acc[season]) {
        acc[season] = [];
      }

      acc[season].push(item);
      return acc;
    }, {}) || {};

  const Order = ["Core", "Spring", "Summer", "Resort", "Fall", "Holiday"];


  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing PDF Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      await form.validateFields().then(async (values) => {
        const data = {
          date_from: moment(values.from_date).format("MM-DD-YYYY"),
          date_to: moment(values.to_date).format("MM-DD-YYYY"),
          gender_id: values.gender_id === undefined || values.gender_id === "All" ? null : values.gender_id,
          current_season: values.season_id === undefined || values.season_id === "All" ? null : values.season_id,
        }
        const response = await axios.post(`${BASEURL}getAll/DownloadTopImmediateOts`, { data }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type: "application/pdf"
        });
        saveAs(blob, "Top-Immediate-OTS.pdf");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your PDF report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      console.error("Download failed", error);

      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the PDF report.",
        className: "toast-error",
      });
    }
  };


  useEffect(() => {
    if (!token || !menuId) return;

    dispatch(getRights(token, menuId)).then((res) => {
      if (res?.type === "GET_USER_RIGHTS_SUCCESS") {
        setUserRights(res?.payload?.can_add ?? false);
      } else {
        setUserRights(false);
      }
    });
  }, [dispatch, menuId, token]);

  const handleSchedule = () => {
    form.validateFields().then((values) => {
      const report_filters = {
        date_from: moment(values.from_date).format("MM-DD-YYYY"),
        date_to: moment(values.to_date).format("MM-DD-YYYY"),
        gender_id: values.gender_id === undefined || values.gender_id === "All" ? null : values.gender_id,
        current_season: values.season_id === undefined || values.season_id === "All" ? null : values.season_id,
      };

      const getNameFromList = (list, id, idKey, nameKey, defaultValue = "All") => {
        if (!id || id === "All") return defaultValue;

        const item = list?.find((it) => it[idKey] === id);
        return item ? item[nameKey] : defaultValue;
      };


      // Labels for UI
      const uiData = {
        "From Date": moment(values.from_date).format("MM-DD-YYYY"),
        "To Date": moment(values.to_date).format("MM-DD-YYYY"),
        Gender: getNameFromList(gender?.payload?.data, values.gender_id, "gender_id", "gender_name"),
        Season: values.season_id,
      };
      const report_columns = {
      };
      const emailDates = {
        from: moment(values.from_date).format("MM-DD-YYYY"),
        to: moment(values.to_date).format("MM-DD-YYYY")
      };
      setScheduleData({
        uiData,
        report_filters,
        report_columns,
        report_id: 2,
        report_name: "Top Immediate OTS",
        api_route: "/DownloadTopImmediateOts",
        type: "pdf",
        emailDates
      });

      setIsModalOpen(true);
    }).catch(errorInfo => {
      console.log("Form validation failed:", errorInfo);
    });
  };




  return (
    <>
      <ScheduleModal
        token={token}
        open={isModalOpen}
        data={scheduleData || {}}
        onClose={() => setIsModalOpen(false)}
      />
      <div className="styleContainer">
        <div className="styleBodyPendingSummary">
          <PageHeader
            title={"Top Immediate OTS"}
            minimize={setMinimize}
            check={minimize}
          />
          {!minimize && (
            <div className="bodyStyle">
              <div className="formProduct p-2">
                <Form onFinish={onFinish} form={form} name="control-hooks">
                  <div className="container-fluid pbpx-5 ptpx-5">
                    <Brow>
                      <Bcol lg={6} xl={4} xxl={4}>
                        <div className="">
                          <div className="relative">
                            <Form.Item
                              name="from_date"
                              label="Booking From:"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={moment().startOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                                defaultValue={moment().format("MM-DD-YYYY")}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={4}>
                        <div >
                          <div className="relative">
                            <Form.Item
                              name="to_date"
                              label=" Booking To:"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={moment().endOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                                defaultValue={moment().format("MM-DD-YYYY")}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={4}>
                        <div >
                          <div className="relative">
                            <Form.Item
                              label="Gender"
                              name="gender_id"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={"All"}>
                              <Select
                                showSearch
                                optionFilterProp="children"
                                size="small"
                              >
                                <Option value="All">All</Option>
                                {gender &&
                                  gender?.payload?.data.map((it, index) => {
                                    return (
                                      <Option key={index} value={it.gender_id}>
                                        {it.gender_name}
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={4}>
                        <div >
                          <div className="relative">
                            <Form.Item
                              label="Season"
                              name="season_id"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={"All"}>
                              <Select

                                showSearch
                                optionFilterProp="children"
                                size="small"
                              >
                                <Option value="All">All</Option>
                                <Option value="Core">Core</Option>
                                <Option value="Spring">Spring {moment().format("YY")}</Option>
                                <Option value="Summer">Summer {moment().format("YY")}</Option>
                                <Option value="Resort">Resort {moment().format("YY")}</Option>
                                <Option value="Fall">Fall {moment().format("YY")}</Option>
                                <Option value="Holiday">Holiday {moment().format("YY")}</Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                    </Brow>
                    <Brow>
                      <Bcol lg={12} className="d-flex justify-content-end" >
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="submit-btn-btm m-0 "
                        >
                          Submit
                        </Button>
                      </Bcol>
                      <div className="col-12 col-md-4">
                        <div
                          className=" d-flex flex-row align-items-baseline"
                          style={{
                            justifyContent: "start",
                            marginTop: "3px",
                          }}
                        >
                          {userRights && (
                            <Button type="primary" onClick={handleSchedule}>
                              Schedule
                            </Button>
                          )}
                        </div>
                      </div>
                    </Brow>
                  </div>
                </Form>

              </div>
            </div>
          )}
        </div>
        <div style={{ marginTop: 10 }}>
          {
            loading ? (
              <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                <Spin size='large' />
              </div>
            ) : (
              topImmediateOts && topImmediateOts?.payload?.data.length > 0 ? (
                <>
                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex" }}>
                        <span className="print_icon printing_class" onClick={handleDownload}>
                          <input
                            style={{ height: "30px", cursor: "pointer" }}
                            type="image"
                            name="ImgPdf"
                            alt="Export to PDF"
                            id="ImgPdf"
                            title="Export to PDF"
                            src={pdf}
                          />
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                      {Order.map((season) => {
                        const seasonData = groupedData[season];

                        if (!seasonData || seasonData.length === 0) return null;

                        return (
                          <div key={season} style={{ width: "100%" }}>
                            {/* Season Heading */}
                            <h3 style={{ marginTop: "20px" }}>{season === "Core" ? season : `${season}-${moment().format("YY")}`}</h3>

                            <div style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
                              {seasonData.map((val, i) => (
                                <div key={i} style={{ marginBottom: "40px" }}>
                                  {/* 👇 tumhara existing card same rahega */}
                                  <div
                                    style={{
                                      width: "120px",
                                      height: "300px",
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      textAlign: "center",
                                      fontSize: "10.5px",
                                      fontFamily: "Arial, sans-serif",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div className="sku-text">{val.sku_inseam}</div>

                                    <div style={{ marginBottom: "4px" }}>
                                      <div style={{ fontWeight: "bold", fontSize: "10px" }}>
                                        {val.style_name}
                                      </div>
                                      <div style={{ color: "#666", fontSize: "9px" }}>
                                        {val.wash_name}
                                      </div>
                                    </div>

                                    <div style={{ height: "180px" }}>
                                      <Image
                                        src={val.image_url || noImage}
                                        alt={val.style_name}
                                        width={100}
                                        height={150}
                                        style={{ objectFit: "contain" }}
                                        preview={false}
                                      />
                                    </div>

                                    <div style={{ fontWeight: "bold", fontSize: "11px" }}>
                                      OTS: {numeral(val.ots_qty).format("0")}
                                    </div>
                                    <div style={{ fontWeight: "bold", fontSize: "11px" }}>
                                      Booking: {numeral(val.booking_qty).format("0")}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>) : <div
                  style={{
                    backgroundColor: "#CCCCCC",
                    borderWidth: "1pt",
                    borderStyle: "Dashed",
                    fontWeight: "bold",
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                No record(s)
              </div>
            )
          }
        </div>

      </div>
    </>
  )
}

export default TopImmediateOts;